export const loginUrl = `${process.env.REACT_APP_PFPLUS_FRONTEND_URL}/login`;
